import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { of } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';
import { DirectoryColumn } from 'src/app/samwebDescription/samweb/directory/directory-column';
import { DirectoryOrganisationDataSelectors } from 'src/app/store/samwin/directory/directory-organisation-data/directory-organisation-data.selectors';
import { OrganisationEntryRemoteDto } from 'src/generated/swagger';

@Pipe({
   name: 'directoryColumnStructureData',
})
export class DirectoryColumnStructureDataPipe implements PipeTransform {
   constructor(private store: Store) {}
   transform(directoryColumn: DirectoryColumn): Observable<OrganisationEntryRemoteDto[]> {
      const isOrgField = !_.isNil(directoryColumn.columnTyp.enumName.toUpperCase().match(new RegExp('/*FLD_ORG+[0-9]+[0-9]', 'g')));
      if (!isOrgField) {
         return of(null);
      }
      const key = directoryColumn.columnTyp.enumName.slice(-2);
      const result = this.store.select(DirectoryOrganisationDataSelectors.getDirectoryStructureDataForOrgFn).pipe(map((getEntry) => getEntry(key)));
      return result;
   }
}
